// src/App.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import muiTheme from "./theme";

import Home from "./scenes/home";
import AnimalIncident from "./scenes/animalincident";
import Sidebar from "./scenes/global/Sidebar";

function App() {
    return (
        <ThemeProvider theme={muiTheme}>
            <CssBaseline />

            <Routes>
                {/* All routes using the sidebar layout */}
                <Route element={<Sidebar />}>
                    <Route path="/home" element={<Home />} />
                    {/* add other routes that should keep the sidebar here */}
                </Route>

                {/* AnimalIncident no longer wrapped in Sidebar */}
                <Route path="/animal-incident" element={<AnimalIncident />} />

                {/* root → home */}
                <Route path="/" element={<Navigate to="/home" replace />} />

                {/* any other URL → home */}
                <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
        </ThemeProvider>
    );
}

export default App;
